import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { publish } from "@api/courses/exams/interactive/publish/path";
import { questions } from "@api/courses/exams/interactive/questions/path";
import { interactiveExamAttempt } from "@api/courses/exams/interactive/attempts/path";

const pathBase = `/courses/:courseId/exams/interactive`;
const pathById = `${pathBase}/:examId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const interactive = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  publish,
  questions,
  interactiveExamAttempt,
} as const;
